import { render } from "./RetrieveUsername.vue?vue&type=template&id=9884995c"
import script from "./RetrieveUsername.vue?vue&type=script&lang=js"
export * from "./RetrieveUsername.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__